import { TripModalComponent } from "./trip-modal/trip-modal.component";
import { TripRowComponent } from "./trip-modal/trip-row/trip-row.component";
import { TripFilterComponent } from "./trip-search-bar/filter/filter.component";
import { TripSearchBarComponent } from "./trip-search-bar/trip-search-bar.component";

export {
  TripModalComponent,
  TripRowComponent,
  TripSearchBarComponent,
  TripFilterComponent
};

export const tripComponents = [
  TripModalComponent,
  TripRowComponent,
  TripSearchBarComponent,
  TripFilterComponent
]